import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { AppComponentsModule } from '../components/app/app-components.module';
import { AppModalsModule } from '../modals/app/app-modals.module';
import { GenericModalsModule } from '../modals/generic/generic-modals.module';
import { DirectivesModule } from '../directives/directives.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PipesModule } from '../pipes/pipes.module';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { AppComponentsGenericModule } from '../components/generic/generic-components.module';
import { NgbCarouselModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';

const modules = [
  CommonModule,
  FormsModule,
  IonicModule,
  AppComponentsGenericModule,
  AppComponentsModule,
  AppModalsModule,
  GenericModalsModule,
  DirectivesModule,
  FlexLayoutModule,
  PipesModule,
  NgxChartsModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  NgbModule,
  NgbCarouselModule
];

@NgModule({
  declarations: [],
  imports: [...modules],
  exports: [...modules]
})
export class PagesModule { }
